module.exports = __webpack_public_path__ + "img/paper_texture.6f08e5e3.jpg";